import { EntityOutputqueue } from "../../entity/EntityOutputqueue";

export class DtoOutputqueuesDeleteRes extends EntityOutputqueue {
  public message: string | null = null;
}
